/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
/* eslint-enable no-console */

// import Swiper JS
import Swiper from "swiper/bundle";
// import Swiper styles

const sliders = document.querySelectorAll(".wp-block-ldx-slider");
sliders.forEach((slider) => {
	const swiperSpeed = parseInt(
		slider.querySelector(".ldx-slider").dataset.speed,
	);
	const swiperSlideSpeed = parseInt(
		slider.querySelector(".ldx-slider").dataset.slidespeed,
	);
	const swiperLoop =
		slider.querySelector(".ldx-slider").dataset.loop === "true" ? true : false;
	const swiperDirection = slider.querySelector(".ldx-slider").dataset.direction;

	// Function to determine direction based on screen width
	const getDirection = () => { 
		const dir = window.innerWidth <= 768 ? "horizontal" : swiperDirection;
		return dir;
	};

	const swiper = new Swiper(".ldx-slider", {
		autoplay: {
			delay: swiperSpeed,
		},
		speed: swiperSlideSpeed,
		spaceBetween: 0,
		loop: swiperLoop,
		direction: getDirection(),
		autoHeight: true,
		pagination: {
			el: ".swiper-pagination.slider",
			clickable: true,
		},
	});

	// Update direction on window resize
	window.addEventListener("resize", () => {
		swiper.changeDirection(getDirection());
	});
});
